"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.conversationDisconnected = void 0;
var UserAction = _interopRequireWildcard(require("@ori-events/user-action"));
var _esToolkit = require("es-toolkit");
var _constants = require("../constants");
var _models = require("../models");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Handles the conversation disconnected event from Genesys.
 * Dispatches a user action event if the conversation was ended by a human agent
 * and the disconnection time is after the initial time. This is due to Genesys
 * repeating the conversation when the user opens chat again.
 */
const conversationDisconnected = exports.conversationDisconnected = (0, _esToolkit.debounce)(({
  event,
  initialTime
}) => {
  const agentDisconnected = event.data?.message?.originatingEntity === _models.OriginatingEntity.Human;
  const {
    time: channelTime
  } = event.data?.message?.channel ?? {};
  const disconnectTime = new Date(channelTime ?? '').getTime();
  if (!agentDisconnected || !channelTime || disconnectTime < initialTime) {
    return;
  }
  UserAction.dispatch(_constants.GENESYS_CONVERSATION_DISCONNECTED);
}, 500);
